(() => {
  const project = document.currentScript?.dataset.dhClarity;
  if (!project || !/^[a-z0-9]+$/i.test(project)) return;
  let loaded = false;
  const applyConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    const consent = privacy?.currentVisitorConsent?.();
    const analytics = consent?.analytics === 'yes' && privacy.analyticsProcessingAllowed();
    const marketing = consent?.marketing === 'yes' && privacy.marketingAllowed();
    if (analytics && !loaded) {
      window.clarity = window.clarity || function () {(window.clarity.q = window.clarity.q || []).push(arguments);};
      window.clarity('consentv2', {analytics_Storage:'granted', ad_Storage:marketing ? 'granted' : 'denied'});
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + project;
      document.head.appendChild(script);
      loaded = true;
    } else if (loaded) {
      window.clarity('consentv2', {analytics_Storage:analytics ? 'granted' : 'denied', ad_Storage:marketing ? 'granted' : 'denied'});
      if (!analytics) window.clarity('consent', false);
    }
  };
  document.addEventListener('visitorConsentCollected', applyConsent);
  if (window.Shopify?.customerPrivacy) applyConsent();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) applyConsent();});
})();
